import {
  mdiAccountHardHat,
  mdiAlert,
  mdiElevator,
  mdiExitRun,
  mdiHospitalBox,
  mdiMapMarker,
} from '@mdi/js';

export const ICON_OPTIONS = [
  { name: 'map-marker', displayName: 'Sijainti', icon: mdiMapMarker },
  { name: 'health', displayName: 'Ensiapu', icon: mdiHospitalBox },
  { name: 'elevator', displayName: 'Hissi', icon: mdiElevator },
  { name: 'emergency-exit', displayName: 'Hätäpoistumistie', icon: mdiExitRun },
  { name: 'hard-hat', displayName: 'Kypärä', icon: mdiAccountHardHat },
  { name: 'alert', displayName: 'Hälytys', icon: mdiAlert },
];

export const getIconByName = (name) =>
  ICON_OPTIONS.find((i) => i.name === name) ?? ICON_OPTIONS[0];
